import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=1c8fb230&"
import script from "./Warehouse.vue?vue&type=script&lang=js&"
export * from "./Warehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8fb230')) {
      api.createRecord('1c8fb230', component.options)
    } else {
      api.reload('1c8fb230', component.options)
    }
    module.hot.accept("./Warehouse.vue?vue&type=template&id=1c8fb230&", function () {
      api.rerender('1c8fb230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Warehouse.vue"
export default component.exports